import { Heading, HeadingLevel } from 'blaze-ui/Heading/Heading'
import Styles from '../TemplatesV2.module.scss'
import { Search } from './Search'
import { Filters } from './Filters'
import { FilterKey, IFilters } from '../Types'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export interface HeaderProps {
  heading: string
  headingLevel?: HeadingLevel
  filters: IFilters
  onFilterChange: (f: IFilters) => any
  minHeight: number
  hiddenFilters?: FilterKey[]
  disabledFilters?: FilterKey[]
  headerClassName?: string
}

export const Header = ({
  heading,
  headingLevel = 2,
  filters,
  onFilterChange,
  minHeight,
  hiddenFilters,
  disabledFilters,
  headerClassName,
}: HeaderProps) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.header} style={{ minHeight: isMobile ? undefined : `${minHeight}px` }}>
      <ResponsiveDesign.Desktop>
        {!headerClassName && (
          <Heading level={headingLevel} color="var(--light-100)">
            {heading}
          </Heading>
        )}
        {headerClassName && <h1 className={headerClassName}>{heading}</h1>}
      </ResponsiveDesign.Desktop>
      <div className={Styles.headerSearchContainer} style={{ paddingTop: '15px' }}>
        <Search
          query={filters.query}
          onChange={(newQuery) => onFilterChange({ ...filters, query: newQuery })}
          useCompactUI={isMobile}
        />
      </div>
      <Filters
        value={filters}
        onChange={onFilterChange}
        useCompactUI={isMobile}
        hiddenFilters={hiddenFilters}
        disabledFilters={disabledFilters}
      />
    </div>
  )
}
